import { reactive, ref, watch } from 'vue';
import { EligibleAthlete } from '@/types/athletes';

interface UseAgreementAthletesDialogState {
  isOpen: boolean;
  onAdd: (() => void) | undefined;
  selectedAthletes?: EligibleAthlete[];
}

const DEFAULT_STATE: UseAgreementAthletesDialogState = {
  isOpen: false,
  onAdd: undefined,
  selectedAthletes: undefined,
};

const getDefaultState = () => ({ ...DEFAULT_STATE });

const state = reactive<UseAgreementAthletesDialogState>(getDefaultState());

function resetState() {
  Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
  if (isOpen && !isRendered.value) isRendered.value = true;
  if (!isOpen) resetState();
});

interface useAgreementAthletesDialogOptions {
  onAdd?: () => void;
}

export function useAgreementAthletesDialog(options?: useAgreementAthletesDialogOptions) {
  async function open(selectedAthletes?: EligibleAthlete[]) {
    state.isOpen = true;
    state.onAdd = options?.onAdd;
    state.selectedAthletes = selectedAthletes;
  }

  return {
    state,
    isRendered,
    resetState,
    open,
  };
}
